import "./GlobalNav.css";

import React, {useCallback, useContext} from "react";
import {useState, useEffect}            from "react";
import {Link, useLocation}                    from "react-router-dom";
import {Badge, Menu, Layout, Button, Tooltip} from "antd";
import Icon, {LeftOutlined, RightOutlined}    from "@ant-design/icons";
import {IoSpeedometerOutline}                 from "react-icons/io5";
import {IoMdExit}                             from "react-icons/io";
import {Scrollbars}                           from "react-custom-scrollbars";
import locale                                 from "../../localization/locale";
import LayoutContext                          from "../contexts/LayoutContext";
import {primaryColor}                         from "../../styles";
import selector                               from "../../js/selector.json";
import api                                    from "@tools/api";
import GlobalContext                          from "@components/contexts/GlobalContext";
import webSocket                              from "@tools/web_socket";

const pageToNotificationsMap = {
    help_center: "issue"
}

const { Sider } = Layout

let get_section_url = url =>
   url.split("/").slice(0, 2).join("/");


const GlobalNav = props => {
    const { menus, hideHomeButton, cbLogout} = props
    const {state, dispatch} = useContext(GlobalContext)
    const {notifications} = state;
    const iconSize = "18px"
    const iconColor = "rgba(0, 0, 0, 0.60)"

    const { pathname } = useLocation()
    const currentLocation = pathname.split("/")[1]

    const {
        compactMenu,
        setCompactMenu,
        siderNormalWidth,
        siderCompactWidth,
    } = useContext(LayoutContext)

    const [menuList, setMenuList] = useState(menus)

    const logoutHandler = useCallback(() => {
       cbLogout()
    }, [cbLogout])

    useEffect(() => {
        api("readNotificationsCount", {}).then(result => {
            dispatch({
                type: "create_notifications",
                value: result?.reduce((res, item) => {
                    res[item.index.replace("fuel_", "")] = item
                    return res;
                }, {})
            })
        })

        const ev = webSocket.on("message", data => {
            const {type} = data
            if(type === "alert_created") {
                dispatch({
                    type: "update_notifications",
                    value: {name: "alert", count: {"action" :"inc", value: 1}}
                })
            }
            else if(type === "issue_created") {
                dispatch({
                    type: "update_notifications",
                    value: {name: "issue", count: {"action" :"inc", value: 1}}
                })
            }
        })

        return () => {ev.off()}
    }, [])

    useEffect(() => {
        setMenuList(menus)
    }, [menus])

    const getMenuContent = useCallback(({id, url = "",icon = null}) => {
        const content =  <div
            className={
                compactMenu
                    ? "globalNavItem compactGlobalNavItem"
                    : "globalNavItem"
            }
        >
            {icon && (
                <Icon
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                        marginRight: compactMenu
                            ? "0"
                            : "10px",
                    }}
                    component={icon}
                />
            )}

            {!compactMenu && (
                <div className="globalNavItemTitle">
                    {locale.get("navbar", id)}
                </div>
            )}
            <Link
                data-test={selector.navbar.button[id]}
                to={get_section_url(url)}
                style={{
                    fontSize: 0,
                    lineHeight: 0,
                    color: "transparent",
                }}
            >
                {locale.get("navbar", id)}
            </Link>
        </div>

        if (compactMenu)
            return <Tooltip placement="left" title={locale.get("navbar", id)}>
                {content}
            </Tooltip>

        return content
    }, [compactMenu])

    const renderLogoutBtn = useCallback(() => {
        const content = <Menu.Item key={"logout"} onClick={logoutHandler} >
            <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Icon
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                        marginTop: 8,
                        marginRight: compactMenu ? "0" : "10px",
                    }}
                    component={IoMdExit}
                />

                {!compactMenu && (
                    <div className="globalNavItemTitle">
                        {locale.get("navbar.exit")}
                    </div>
                )}
            </div>
            <Link
                data-test={selector.navbar.button.logout}
                to={"/"}
                style={{
                    fontSize: 0,
                    lineHeight: 0,
                    color: "transparent",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%"
                }}
            >
                {locale.get("navbar.exit")}
            </Link>
        </Menu.Item>

        if (compactMenu)
            return <Tooltip placement="left" title={locale.get("navbar.exit")}>
                {content}
            </Tooltip>

        return content

    }, [compactMenu, logoutHandler])

    return (
        <>
            <Sider
                width={compactMenu ? siderCompactWidth : siderNormalWidth}
                style={{
                    height: "100vh",
                    position: "fixed",
                    left: 0,
                    zIndex: 99,
                }}
                theme="light"
                data-test={selector.navbar.container}
            >
                {menuList.length > 0 && <Button
                    type="primary"
                    shape="circle"
                    size="small"
                    icon={
                        compactMenu ? (
                            <RightOutlined
                                style={{color: "rgba(255, 255, 255, 0.65)"}}
                            />
                        ) : (
                            <LeftOutlined
                                style={{color: "rgba(255, 255, 255, 0.65)"}}
                            />
                        )
                    }
                    onClick={() =>
                        compactMenu
                            ? setCompactMenu(false)
                            : setCompactMenu(true)
                    }
                    style={{
                        position: "absolute",
                        right   : "-11px",
                        bottom  : "60px",
                        zIndex  : 10
                    }}
                />}

                {!hideHomeButton && <Link to="/" data-test={selector.navbar.button.home}>
                    <div className="globalNavHeader">
                        <div className="globalNavHeaderLogo">
                            <IoSpeedometerOutline color={primaryColor} size="1.5em"/>
                        </div>
                        {!compactMenu && (
                            <h1 className="globalNavHeaderTitle">
                                {locale.get("app_name")}
                            </h1>
                        )}
                    </div>
                </Link>}
                <Scrollbars>
                <Menu
                    defaultSelectedKeys={[currentLocation]}
                    selectedKeys={[currentLocation]}
                    inlineIndent={16}
                    mode="inline"
                >
                    <Menu.Divider />
                    {menuList.map(data => {
                        return (<Menu.Item key={data.id}>
                                <Badge key={data.id} dot={notifications[pageToNotificationsMap[data.id] || data.id]?.count} style={{left: 14, top: -3, right: "initial", transform: "none"}} size={"small"}>
                                {getMenuContent(data)}
                            </Badge>
                        </Menu.Item>
                        )}
                    )}
                </Menu>
                </Scrollbars>
                <Menu className="logOutMenu">
                    <Menu.Divider />
                    {renderLogoutBtn()}
                </Menu>
            </Sider>
        </>
    )
}

GlobalNav.defaultProps = {
    cbLogout: () => {},
}

export default GlobalNav
